import { gql } from '@apollo/client';

const queryAllData = `
  apiKey
  customer
  username
  password
`;

export const GET_TIMEOS_CONFIGURATION = gql`
    query getTimeosConfiguraton {
        timeosConfiguration {
            ${queryAllData}
        }
    }
`;

export const UPDATE_TIMEOS_CONFIGURATION = gql`
    mutation updateTimeosConfiguration($data: UpdateTimeosConfigurationInput!) {
        timeosConfiguration(data: $data) {
            ${queryAllData}
        }
    }
`;

export const VALIDATE_TIMEOS_CONFIGURATION = gql`
  mutation validateTimeosConfiguration {
    validateTimeosConfiguration
  }
`;

export const GET_UNREAD_MESSAGES = gql`
  query getUnreadMessages($userId: String!) {
    getUnreadMessages(userId: $userId)
  }
`;
